<div class="authincation">
  <div class="container-fluid h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-6 col-md-7 col-sm-12 mx-auto mt-md-0 mt-4">
        <div class="login-form p-4">
          <div class="text-center">
            <h3 class="title">{{ "auth.reset-password" | translate }}</h3>
          </div>
          <form [formGroup]="resetPasswordForm">
            <div class="mb-4">
              <label class="mb-1 text-dark" for="">{{
                "auth.new-password" | translate
              }}</label>
              <div class="position-relative">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  class="form-control"
                />
                <span
                  class="show-pass eye"
                  (click)="togglePasswordVisibility('password')"
                  role="button"  tabindex="-1"
                >
                  <i
                    class="pi"
                    [ngClass]="showPassword ? 'pi-eye' : 'pi-eye-slash'"
                  ></i>
                </span>
              </div>
              <div *ngIf="resetPasswordForm.get('password')?.touched && resetPasswordForm.get('password')?.errors">
                <small class="text-danger" *ngIf="resetPasswordForm.get('password')?.hasError('required')">
                  {{ "auth.password-required" | translate }}
                </small>
                <small class="text-danger" *ngIf="resetPasswordForm.get('password')?.hasError('pattern')">
                  {{ "auth.password-pattern-error" | translate }}
                </small>
              </div>
            </div>

            <div class="mb-4">
              <label class="mb-1 text-dark" for="">{{
                "auth.new-password-confirm" | translate
              }}</label>
              <div class="position-relative">
                <input
                  [type]="showPasswordConfirm ? 'text' : 'password'"
                  formControlName="passwordConfirm"
                  class="form-control"
                />
                <span
                  class="show-pass eye"
                  (click)="togglePasswordVisibility('passwordConfirm')"
                  role="button"  tabindex="-1"
                >
                  <i
                    class="pi"
                    [ngClass]="showPasswordConfirm ? 'pi-eye' : 'pi-eye-slash'"
                  ></i>
                </span>
              </div>
              <div *ngIf="resetPasswordForm.get('passwordConfirm')?.touched && resetPasswordForm.get('passwordConfirm')?.errors">
                <small class="text-danger" *ngIf="resetPasswordForm.get('passwordConfirm')?.hasError('required')">
                  {{ "auth.password-confirm-required" | translate }}
                </small>
                <small class="text-danger" *ngIf="resetPasswordForm.get('passwordConfirm')?.hasError('minlength')">
                  {{ "auth.password-minlength-error" | translate }}
                </small>
                <small class="text-danger" *ngIf="resetPasswordForm.get('passwordConfirm')?.hasError('maxlength')">
                  {{ "auth.password-maxlength-error" | translate }}
                </small>
                <small class="text-danger" *ngIf="resetPasswordForm.get('passwordConfirm')?.hasError('passwordsMismatch')">
                  {{ "auth.passwords-mismatch-error" | translate }}
                </small>
              </div>
            </div>
            <div class="text-center mb-4">
              <button
                type="submit"
                class="btn btn-primary btn-block"
                (click)="submitForm()"
              >
                {{ "auth.reset-password" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6 col-md-5 d-none d-md-block">
        <div class="login-media text-center mt-md-0 mt-4">
          <img
            src="assets/theme/w3crm/images/acibadem-mobil-logo.png"
            class="acibadem-logo"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</div>
